import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-tcg-filter-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./tcg-filter-modal.component.html",
  styleUrl: "./tcg-filter-modal.component.scss",
})
export class TcgFilterModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;
  selectedStory:any = "";
  selectedPriority:any = "";

  @Input() userStories: any[] = [];
  @Input() priorities: any[] = ['Critical','High'];
  @Input() title: string = "Filter by";
  @Input() previousData: any;
  priorityMap: Record<string, string> = {
    P1: 'Critical',
    P2: 'High',
    P3: 'Medium',
    P4: 'Low'
  };

  ngOnInit(): void {
    if(this.previousData){
      this.selectedStory = this.previousData?.story;
      this.selectedPriority = this.getPriorityLabel(this.previousData?.priority);
    }
  }

  apply() {
    this.activeModal.close({
      story: this.selectedStory,
      priority: this.getPriorityCode(this.selectedPriority)
    });
  }

  onSelectChange(){}

  getPriorityClass(priority: string): string {
    switch (priority?.toLowerCase()) {
      case 'critical':
        return 'priority-critical';

      case 'high':
        return 'priority-high';

      case 'medium':
        return 'priority-medium';

      case 'low':
        return 'priority-low';

      default:
        return 'priority-default';
    }
  }

  getPriorityLabel(priorityCode: string): string {
    return this.priorityMap[priorityCode?.toUpperCase()] || '';
  }

  getPriorityCode(priorityLabel: string): string {
    const entry = Object.entries(this.priorityMap)
    .find(([_, label]) => label.toLowerCase() === priorityLabel?.toLowerCase());
    return entry ? entry[0] : '';
  }

  resetAll(){
    this.selectedPriority = "";
    this.selectedStory = "";
  }

  selectPriority(priority: string): void {
    this.selectedPriority = priority;
  }
}
